import Component from './component'
import ContentDataGetter from 'layers/content/v2/Hocs/ContentDataGetter'
import { ENTRY_ID, QUERY_TYPE } from './constants'

export default ContentDataGetter(Component, {
  entryId: ENTRY_ID,
  queryType: QUERY_TYPE,
})
